"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowPositioning = void 0;
const edge_1 = require("../enums/edge");
const window_type_1 = require("../enums/window_type");
const logger_service_1 = require("../../common/logging/logger_service");
const monitor_helper_1 = require("../utils/monitor_helper");
/** @internal */
class WindowPositioning {
    // ---------------------------------------------------------------------------
    /**
     * Docks the window to the given edge.
     * @param window
     * @param dock
     * @returns
     */
    static async setDockPosition(params) {
        switch (params === null || params === void 0 ? void 0 : params.window.type()) {
            case window_type_1.WindowType.Desktop:
                this.setWindowDockPosition(params);
                break;
            case window_type_1.WindowType.Offscreen:
                this.setOffscreenWindowDockPosition(params);
                break;
        }
    }
    // ---------------------------------------------------------------------------
    /**
     * Centers the window
     * @param window
     * @param monitor
     * @returns
     */
    static async centerWindow(window, monitor) {
        return new Promise(async (resolve, reject) => {
            const rect = this.getCenterPos(window, monitor);
            this.logger.info(`centering ${window.Id()} at (${rect.x}, ${rect.y})`);
            overwolf.windows.changePosition(window.Id(), rect.x, rect.y, posRes => {
                if (!posRes.success) {
                    reject();
                }
                else {
                    resolve(true);
                }
            });
        });
    }
    // ---------------------------------------------------------------------------
    static getCenterPos(window, monitor) {
        const { width: winWidth, height: winHeight, dpiAwareWidth: winDpiWidth, dpiAwareHeight: winDpiHeight, } = window.getBounds();
        const isDesktop = window.type() === window_type_1.WindowType.Desktop;
        const width = isDesktop ? winWidth : winDpiWidth;
        const height = isDesktop ? winHeight : winDpiHeight;
        return {
            x: Math.round(monitor.left + monitor.width / 2 - width / 2),
            y: Math.round(monitor.top + monitor.height / 2 - height / 2),
        };
    }
    // ---------------------------------------------------------------------------
    static async setOffscreenWindowDockPosition(params) {
        return new Promise(async (resolve, reject) => {
            if (!params || !params.window || !params.edge) {
                return;
            }
            params.monitor = await monitor_helper_1.MonitorHelper.getWindowMonitor(params.window);
            resolve(await this.setWindowDockPosition(params));
        });
    }
    // ---------------------------------------------------------------------------
    static async setWindowDockPosition(params) {
        return new Promise(async (resolve, reject) => {
            if (!params || !params.window || !params.edge) {
                return;
            }
            const { window, edge: dock, monitor, marginOptions } = params;
            const { width, height, left, top } = monitor;
            const { dpiAwareWidth: winWidth, dpiAwareHeight: winHeight } = window.getBounds();
            const rect = this.getCenterPos(window, monitor);
            if (edge_1.Edge.isTop(dock)) {
                const margin = marginOptions.marginY
                    ? marginOptions.marginY
                    : marginOptions.marginX;
                rect.y = top + margin;
            }
            if (edge_1.Edge.isLeft(dock)) {
                const margin = marginOptions.marginX;
                rect.x = left + margin;
            }
            if (edge_1.Edge.isRight(dock)) {
                const margin = marginOptions.marginX;
                rect.x = width + left - winWidth - margin;
            }
            if (edge_1.Edge.isBottom(dock)) {
                const margin = marginOptions.marginY
                    ? marginOptions.marginY
                    : marginOptions.marginX;
                rect.y = height + top - winHeight - margin;
            }
            const result = await window.setBounds(rect);
            resolve(result);
        });
    }
}
exports.WindowPositioning = WindowPositioning;
WindowPositioning.logger = logger_service_1.LoggerService.getLogger().getChildCategory('WindowPositioning');
//# sourceMappingURL=window_positioning.js.map